/*  eslint-disable */

import * as React from 'react';
import {
  Backdrop,
  Button,
  FormControl,
  MenuItem,
  Modal,
  Grid,
  Select,
} from '@material-ui/core';
import ConfirmModal from 'components/atoms/ConfirmModal';
import NewDailyBulletinPlanning from 'components/organisms/NewDailyBulletinPlanning';
import NewDailyBulletinPreview from 'components/organisms/NewDailyBulletinPreview';
import { postExecutorFilter, postTypeArea } from 'services/executor';
import { useInfiniteQuery, useQuery } from 'react-query';
import { useDispatchFilter, useSelectFilter } from 'hooks/planning/useFilter';
import InputLabel from '@mui/material/InputLabel';
import qs from 'querystring';
import {
  getEquipmentGridData,
  postBopTypes,
  postExecuterInstallation,
} from 'services/equipment';
import IndeterminateCheckbox from 'components/molecules/NewDaillyBulletimGrids/components/Options';

import { IActivityProps } from 'components/organisms/NewDailyBulletinPlanning/types';
import { IModalAddProps } from './types';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useCallback, useRef, useState } from 'react';

import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

import useStyles, {
  Blocktabs,
  ContentTable,
  ListMachine,
  Title,
  TitleType,
} from './style';
import FilterProvider from 'providers/Filter';
import ChecklistEquipamentOnly from 'components/organisms/ChecklistEquipamentOnly';
import { Autocomplete } from '@material-ui/lab';
import {
  Box,
  TextField,
  TextFieldProps,
  createFilterOptions,
} from '@mui/material';
import LoadingInputEndAdornment from 'components/atoms/LoadingInputEndAdornment';
import Loading from 'components/atoms/Loading';

import {
  IEquipmentModalFinishProps as IEquipmentModalRegisterProps,
  IOption,
} from '../../../ModalAddEquipment/types';
import { useFormik } from 'formik';
import { removeSpecialChar } from 'helpers/removeSpecialChar';
import * as yup from 'yup';
import { IEquipmentGrid } from 'interfaces/Equipment';
import { IFilterOptions } from 'interfaces/SelectOptions';
import AutocompleteMultipleCheckboxTree from 'components/atoms/AutocompleteMultipleCheckboxTree';
import GridTreeOthers from 'components/organisms/GridTreeOthers';
import { ICluster } from 'interfaces/Cluster';
import './styleSplit.css';
import SplitPane from 'react-split-pane';

dayjs.extend(isoWeek);

const TAKE = 100000000;
const NO_OPTIONS_TEXT = 'Nenhum resultado encontrado';

const ModalNewBulletim = ({
  open,
  onClose,
  children,
  values,
  valueToGrid,
}: IModalAddProps) => {
  const classes = useStyles();
  const [fornecedorAdd, setFornecedorAdd] = React.useState('');
  const [openDialogAddFornecedor, setOpenDialogAddFornecedor] =
    useState<boolean>(false);
  const inputFornecedorAdd = useRef<TextFieldProps>(null);
  const install = values[0]?.id;

  const [isLoading, setIsLoading] = React.useState(false);

  const [openConfirmModal, setOpenConfirmModal] = React.useState(false);
  const [toggleState, setToggleState] = React.useState('WTG');

  const [nameActivity, setNameActivity] = React.useState<string[]>([]);
  const [idChecks, setIdChecks] = React.useState<number[]>([]);

  const [tagChecks, setTagChecks] = React.useState<string[]>();
  const [tagCheckbox, SetTagCheckbox] = React.useState<string[]>();

  const [typesBop, setTypesBop] = React.useState<any[]>([]);

  const [equipmentList, setEquipmentList] = React.useState<IEquipmentGrid[]>(
    [],
  );

  const [responseCheckTree, setResponseCheckTree] = React.useState();

  const [valueCheck, setValueCheck] = React.useState([]);
  const [valueCheckBop, setValueCheckBop] = React.useState([]);

  const [clusters, setClusters] = React.useState<ICluster[]>([]);

  const [typeOutros, setTypeOutros] = React.useState<any[]>([]);

  const [valueCheckData, setValueCheckData] =
    React.useState<IActivityProps[]>(valueCheck);
  const equipmentFilter = useSelectFilter('description');

  const [valueIdFornecedor, setValueIdFornecedor] = React.useState<string>('');
  const [valueIdFornecedorBop, setValueIdFornecedorBop] =
    React.useState<string>('');
  const [valueIdFornecedorDiverse, setValueIdFornecedorDiverse] =
    React.useState<string>('');

  const changeFilter = useDispatchFilter();
  const equipmentCode = values[0]?.code;
  //limpa os filtros quando muda de aba
  React.useEffect(() => {
    setToggleState('WTG');
    setValueCheck([]);
    setFilterEquipmentOptionsBulletim([]);
    setValueCheckBop([]);
    setNameActivity([]);
    setIdChecks([]);
    setTagChecks([]);
    SetTagCheckbox([]);
    setTypesBop([]);
    setEquipmentList([]);
    setValueIdFornecedor('');
    setValueIdFornecedorBop('');
    setValueIdFornecedorDiverse('');
    setTypeOutros([]);
  }, [toggleState]);

  const params = React.useMemo(
    () => ({
      equipmentCode,
      equipmentIds: [],
      order: [],
    }),
    [equipmentCode, equipmentFilter],
  );

  const handleChangeFilter = ({
    name,
    value,
  }: {
    name: string;
    value: IFilterOptions[];
  }) => {
    changeFilter(name, value);
  };

  const [resultDataEquip, setResultDataEquip] = React.useState<
    IEquipmentGrid[]
  >([]);

  const [selectOptions, setSelectOptions] = React.useState([
    { label: '', value: '' },
    ...valueCheckData,
  ]);

  const filter = createFilterOptions<IOption>();
  const [locationOption, setLocationOption] = React.useState<IOption | null>(
    null,
  );

  const [fieldsSearchText, setFieldsSearchText] = React.useState<{
    [key: string]: string;
  }>({});

  const [locationOptions, setLocationOptions] =
    React.useState<IOption[]>(valueCheck);

  const providerName = valueCheck;
  const handleChange = event => {
    setValueCheck(event.target.value);
  };

  const handleClickValeu = event => {
    setValueIdFornecedor(event.currentTarget.id);
  };

  const handleChangeBop = event => {
    setValueCheckBop(event.target.value);
  };

  const handleClickValueBop = event => {
    setValueIdFornecedorBop(event.currentTarget.id);
  };

  const handleClickValueDiverse = event => {
    setValueIdFornecedorDiverse(event.currentTarget.id);
  };

  const toggleTab = (index: string) => {
    setToggleState(index);
  };

  const [updatedAt, setUpdatedAt] = React.useState<Date | null>(null);
  const initialState = React.useMemo(
    () => ({
      plan: [{ label: dayjs().year().toString(), value: dayjs().year() }],
      week: [{ label: dayjs().isoWeek().toString(), value: dayjs().isoWeek() }],
      initialDate: [
        {
          label: dayjs().startOf('year'),
          value: dayjs().startOf('year').toISOString(),
        },
      ],
      finalDate: [
        {
          label: dayjs().endOf('month'),
          value: dayjs().endOf('month').toISOString(),
        },
      ],
    }),
    [],
  );

  const [
    clusterFilterOptionsContext,
    installationFilterOptionsContext,
    planFilterOptionsContext,
    weekFilterOptionsContext,
    activityFilterOptionsContext,
    maintenanceTypeFilterOptionsContext,
    equipmentFilterOptionsContext,
    activityStatusFilterOptionsContext,
    indispFilterOptionsContext,
    supplierFilterOptionsContext,
  ] = [
    useSelectFilter('cluster'),
    useSelectFilter('installation'),
    useSelectFilter('plan'),
    useSelectFilter('week'),
    useSelectFilter('activity'),
    useSelectFilter('maintenance-type'),
    useSelectFilter('equipment'),
    useSelectFilter('activity-status'),
    useSelectFilter('indisp'),
    useSelectFilter('supplier'),
  ];

  const allFilterContextsBulletin = [
    clusterFilterOptionsContext,
    installationFilterOptionsContext,
    planFilterOptionsContext,
    weekFilterOptionsContext,
    activityFilterOptionsContext,
    maintenanceTypeFilterOptionsContext,
    equipmentFilterOptionsContext,
    activityStatusFilterOptionsContext,
    indispFilterOptionsContext,
    supplierFilterOptionsContext,
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  const [filterEquipmentOptionsBulletim, setFilterEquipmentOptionsBulletim] =
    React.useState<[]>([]);

  const installationIds = installationFilterOptionsContext.map(item =>
    String(item?.value),
  );
  const pauseFilterEquipment = React.useMemo<boolean>(() => {
    return equipmentFilterOptionsContext.length > 0;
  }, [equipmentFilterOptionsContext]);

  const filterSuppliersRef: any = React.useRef(null);

  // funcao para procurar o fornecedor
  const queryFilterSupplierBulletim = useInfiniteQuery({
    queryKey: [
      'installationFilterOptionsContext',
      [...allFilterContextsBulletin],
    ],
    queryFn: async ({ pageParam = 1 }) => {
      const qsparams = {
        page: pageParam,
        take: TAKE,
      } as { page: number; take: number };

      const params = {
        installationIds,
      } as { [key: string]: (string | number)[] | string | number };

      setIsLoading(true);
      const { data } = await postExecutorFilter(qs.stringify(qsparams), params);
      return data;
    },

    onSuccess: data => {
      setIsLoading(false);

      const options: any = [];
      data?.pages
        .map((item: any) => item.result)
        .flat()
        .map(item1 => {
          if (toggleState === 'WTG') {
            if (
              item1.description === 'GAMESA' ||
              item1.description === 'GE' ||
              item1.description === 'VESTAS' ||
              item1.description === 'ACCIONA'
            ) {
              options.push({
                label: item1.description,
                value: item1.id,
              });
            }
          } else if (toggleState === 'BOP') {
            if (
              item1.description !== 'GAMESA' &&
              item1.description !== 'GE' &&
              item1.description !== 'VESTAS' &&
              item1.description !== 'ACCIONA'
            ) {
              options.push({
                label: item1.description,
                value: item1.id,
              });
            }
          } else if (toggleState === 'OUTROS') {
            if (
              item1.description !== 'GAMESA' &&
              item1.description !== 'GE' &&
              item1.description !== 'VESTAS' &&
              item1.description !== 'ACCIONA'
            ) {
              options.push({
                label: item1.description,
                value: item1.id,
              });
            }
          }
          return options;
        });
      setValueCheckData(options);
      setLocationOptions(options);
    },
  });

  React.useEffect(() => {
    if (toggleState) setToggleState(toggleState);
    queryFilterSupplierBulletim.refetch();
  }, [toggleState]);

  // funcao pra trazer os wtgs
  const type = toggleState;

  React.useEffect(() => {
    const fetchData = async () => {
      setIsLoading(false);

      const bodyParams = {
        installationId: values[0]?.id.toString(),
        executor: valueCheck,
        type,
      };
      if (valueCheck.length > 0) {
        if (type !== 'BOP' && valueIdFornecedor !== 'IQONY') {
          setIsLoading(true);

          const data = await postExecuterInstallation(bodyParams);
          const result = data[0];
          setFilterEquipmentOptionsBulletim(result.map(item => item));
        }
      }
      setIsLoading(false);
    };

    if (!pauseFilterEquipment && toggleState !== 'OUTROS') {
      fetchData();
      setFilterEquipmentOptionsBulletim([]);
    }
  }, [valueCheck]);

  // const queryEquipmentsGrid = useInfiniteQuery({
  //   queryKey: [`queryEquipmentsGridForCode${equipmentCode}`, params],
  //   queryFn: async ({ pageParam = 0 }) => {
  //     const qsparams = qs.stringify({
  //       cursor: pageParam,
  //       take: TAKE,
  //     });

  //     const { data } = await getEquipmentGridData({
  //       qsparams,
  //       params,
  //       isRootLevel: true,
  //     });
  //     const resultData = data.result;
  //     setResultDataEquip(resultData);
  //     return data;
  //   },
  //   cacheTime: 0,
  // });

  // query fornecedor outros
  React.useEffect(() => {
    const fetchDataOutros = async () => {
      const bodyParams = {
        areaType: 'OUTROS',
      };
      const data = await postTypeArea(bodyParams);

      const options: any = [];
      data.data.map(item => {
        options.push({
          label: item.description,
          value: item.id,
        });
      });

      setTypeOutros(options);
    };
    fetchDataOutros();
  }, [toggleState === 'OUTROS']);

  React.useEffect(() => {
    const fetchDataOutros = async () => {
      const bodyParams = {
        areaType: 'OUTROS',
      };
      const data = await postTypeArea(bodyParams);

      const options: any = [];
      data.data.map(item => {
        options.push({
          label: item.description,
          value: item.id,
        });
      });

      if (fornecedorAdd)
        options.push({
          label: fornecedorAdd,
          value: 0,
        });

      setTypeOutros(options);
    };
    fetchDataOutros();
  }, [fornecedorAdd]);

  // id do wtg //
  const getIdActivity = (id: number[]): number[] => {
    setIdChecks(id);

    return id;
  };
  // tag do wtg //
  const getTagActivity = (tag: string[]): string[] => {
    setTagChecks(tag);
    return tag;
  };
  const getTahCheckbox = (item: string[]): string[] => {
    SetTagCheckbox(item);
    return item;
  };

  // React.useEffect(() => {
  //   if (locationOption) setLocationOption(locationOption);
  //   queryEquipmentsGrid.refetch();
  // }, [locationOption]);

  // trazendo o valor do checkboxtree
  const checkValueTree = (value: any[]): any[] => {
    const valueCheckTree = value.map(item => item?.value);
    const valueCheckTreeTag = value.map(item => item?.label);
    setIdChecks(valueCheckTree);
    SetTagCheckbox(valueCheckTreeTag);
    return value;
  };

  // tras do component filho o nome da atividade //
  const getNameActivity = (name: string[]): string[] => {
    setNameActivity(name);
    return name;
  };

  React.useEffect(() => {
    const fetchTypeBop = async () => {
      setIsLoading(false);

      const params = {
        installationId: values.map(item => item.id),
      };

      if (params.installationId.length > 0) {
        setIsLoading(true);

        const data = await postBopTypes(params);
        setTypesBop(data);

        return data;
      }
      setIsLoading(false);
    };
    fetchTypeBop();
  }, [toggleState]);

  const onCloseModal = React.useCallback(() => {
    if (open) {
      setOpenConfirmModal(true);
    } else {
      onClose();
    }
  }, [open, onClose]);

  React.useEffect(() => {
    if (Object.keys(fieldsSearchText).length) setFieldsSearchText({});
  }, [fieldsSearchText]);

  React.useEffect(() => {
    if (open && fieldsSearchText?.description === undefined) {
      setFieldsSearchText(cv => ({
        ...cv,
      }));
    }
  }, [fieldsSearchText?.description]);

  const validationSchema = yup.object({
    description: yup.string(),
    location: yup.string().notRequired(),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      location: '',
      description: '',
    },
    validationSchema,
    onSubmit: formValues => {
      const formatedValues = {
        ...formValues,
        location: removeSpecialChar(`${formValues.location}`),
        description: removeSpecialChar(`${formValues.description}`),
      };

      let promise: Promise<unknown> = Promise.resolve();
      // const id = Number(row?.id ?? 0);
    },
  });

  const inputRenderer = React.useCallback(
    (params: TextFieldProps, loading?: boolean) => (
      <TextField
        {...params}
        className={classes.formBaseInput}
        variant="outlined"
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {/* <LoadingInputEndAdornment loading={loading} /> */}
              {params?.InputProps?.endAdornment}
            </>
          ),
        }}
      />
    ),
    [classes.formBaseInput],
  );

  const handleAutoCompleteChange = React.useCallback(
    (name: string, option: IOption) => {
      const value = option?.value || '';
      formik.setFieldValue(name, value);
    },
    [formik],
  );

  const clearFieldSearchTextChange = React.useCallback(
    (event: React.FocusEvent<HTMLInputElement>) => {
      const { name } = event.target;
      setFieldsSearchText(cv => ({ ...cv, [name]: '' }));
    },
    [],
  );

  const selectedInstallations = React.useMemo(() => {
    const installations = clusters.map(cluster => cluster.installations).flat();

    if (installationFilterOptionsContext.length) {
      const installationFilterOptionsIds = installationFilterOptionsContext.map(
        installation => installation.value,
      );

      return installations.filter(installation =>
        installationFilterOptionsIds.includes(installation.id),
      );
    }

    return installations;
  }, [clusters, installationFilterOptionsContext]);

  const selectedInstallationId = values.length > 0 ? values[0].id : null;
  const filteredValueToGrid = valueToGrid.filter(
    item => item.installationId === selectedInstallationId,
  );

  return (
    <>
      {children}
      <ConfirmModal
        title="Confirmar Saída"
        message="É possível que as alterações feitas não sejam salvas."
        open={openConfirmModal}
        width="433px"
        onAccept={() => {
          toggleTab('WTG');
          setValueCheck([]);
          setFilterEquipmentOptionsBulletim([]);
          setValueCheckBop([]);
          onClose();
          setOpenConfirmModal(false);
        }}
        onDecline={() => setOpenConfirmModal(false)}
      />
      <Modal
        BackdropComponent={props => <Backdrop {...props} invisible />}
        open={open}
        onClose={() => {
          onCloseModal();
        }}
        className={classes.presentation}
      >
        <div className={classes.modalPresentation}>
          <div className={classes.modalCard}>
            <div className={classes.container}>
              <div className={classes.boletim}>
                <Blocktabs>
                  <Button
                    type="button"
                    name="WTG"
                    className={
                      toggleState === 'WTG' ? 'tabs active-tabs' : 'tabs'
                    }
                    onClick={() => {
                      toggleTab('WTG');
                    }}
                  >
                    WTG
                  </Button>
                  <Button
                    name="BOP"
                    className={
                      toggleState === 'BOP' ? 'tabs active-tabs' : 'tabs'
                    }
                    onClick={() => toggleTab('BOP')}
                    type="button"
                  >
                    BoP
                  </Button>
                  <Button
                    name="OUTROS"
                    className={
                      toggleState === 'OUTROS' ? 'tabs active-tabs' : 'tabs'
                    }
                    onClick={() => toggleTab('OUTROS')}
                    type="button"
                  >
                    Diversas
                  </Button>
                </Blocktabs>
                <ContentTable>
                  <div
                    className={
                      toggleState === 'WTG'
                        ? 'content  active-content'
                        : 'content'
                    }
                  >
                    <div className="clusterFilter">
                      <h3>{`Instalação: ${values.map(res => res.label)}`}</h3>

                      <div className="options">
                        <Title>Fornecedor</Title>
                        <FormControl
                          variant="outlined"
                          className={classes.formControl}
                        >
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            value={valueCheck}
                            ref={filterSuppliersRef}
                            onChange={handleChange}
                          >
                            {valueCheckData.map(item => (
                              <MenuItem
                                key={item.value}
                                value={item.label}
                                id={item.value}
                                onClick={handleClickValeu}
                              >
                                {item.label}
                              </MenuItem>
                            ))}
                            {/* {isLoading && <Loading />} */}
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                    <ListMachine>
                      <Title>WTGs (por spe)</Title>

                      <IndeterminateCheckbox
                        selecteAllLabel="selecionar"
                        items={filterEquipmentOptionsBulletim}
                        getIdActivity={getIdActivity}
                        getTagActivity={getTagActivity}
                        getTahCheckbox={getTahCheckbox}
                      />
                      {/* {isLoading && <Loading />} */}
                    </ListMachine>
                  </div>

                  <div
                    className={
                      toggleState === 'BOP'
                        ? 'content  active-content'
                        : 'content'
                    }
                  >
                    <div className="clusterFilterBop">
                      <h3>{`Instalação: ${values.map(res => res.label)}`}</h3>
                      <div className="dividerBopFilter">
                        <div className="options">
                          <Title>Fornecedor</Title>
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                          >
                            <Select
                              labelId="BOP"
                              id="Bop"
                              value={valueCheck}
                              ref={filterSuppliersRef}
                              onChange={handleChange}
                            >
                              {valueCheckData.map(item => (
                                <MenuItem
                                  key={item.value}
                                  value={item.label}
                                  id={item.value}
                                  onClick={handleClickValeu}
                                >
                                  {item.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>

                        <div className="optionsArea">
                          <TitleType>Área</TitleType>
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                          >
                            <Select
                              labelId="Type"
                              id="Type"
                              value={valueCheckBop}
                              ref={filterSuppliersRef}
                              onChange={handleChangeBop}
                            >
                              {typesBop.map(item => (
                                <MenuItem
                                  key={item.spe}
                                  value={item.spe}
                                  id={item.spe}
                                  onClick={handleClickValueBop}
                                >
                                  {item.spe}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                    <ListMachine>
                      <Title>BoP</Title>

                      <FilterProvider initialState={initialState}>
                        <ChecklistEquipamentOnly
                          updatedAt={updatedAt}
                          checkboxTree={checkValueTree}
                          responseCheckTree={responseCheckTree}
                          toggleState={toggleState}
                          valueInstalattion={values}
                          valueIdFornecedor={valueIdFornecedorBop}
                        />
                      </FilterProvider>
                    </ListMachine>
                  </div>

                  <div
                    className={
                      toggleState === 'OUTROS'
                        ? 'content2  active-content'
                        : 'content'
                    }
                  >
                    <div className="clusterFilterBop">
                      <div className="dividerBopFilterError">
                        <FormControl
                          variant="outlined"
                          className={classes.formControl}
                        >
                          <Box sx={{ width: 250 }}>
                            <InputLabel className={classes.labelFlutuante}>
                              Instalação
                            </InputLabel>
                            <div className={classes.divTextField}>
                              {' '}
                              {` ${values.map(res => res.label)}`}
                            </div>
                          </Box>
                          <Box sx={{ width: 250 }}>
                            <InputLabel
                              className={classes.labelFlutuante}
                              htmlFor="select-multiple-native"
                            >
                              Fornecedor
                            </InputLabel>

                            <Select
                              labelId="lblDetalhes"
                              id="cmbDetalhes"
                              className={classes.w115}
                              value={valueCheck}
                              ref={filterSuppliersRef}
                              onChange={handleChange}
                            >
                              {typeOutros.map(item => (
                                <MenuItem
                                  key={item.value}
                                  value={item.label}
                                  id={item.value}
                                  onClick={handleClickValeu}
                                >
                                  {item.label}
                                </MenuItem>
                              ))}
                            </Select>

                            <Button
                              variant="outlined"
                              color="primary"
                              className={`${classes.button} ${classes.leftButton} ${classes.btnAdd}`}
                              aria-label="outlined primary button"
                              title="Adicionar novo Fornecedor"
                              onClick={() => {
                                setOpenDialogAddFornecedor(true);
                              }}
                            >
                              <AddCircleOutlineOutlinedIcon />
                            </Button>
                          </Box>
                          <Box sx={{ width: 250 }}>
                            <InputLabel
                              className={classes.labelFlutuante}
                              htmlFor="select-multiple-native"
                            >
                              Área
                            </InputLabel>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <Select
                                labelId="Type"
                                className={classes.wArea}
                                id="Type"
                                value={valueIdFornecedorDiverse}
                                ref={filterSuppliersRef}
                              >
                                {typesBop.map(item => (
                                  <MenuItem
                                    key={item.spe}
                                    value={item.spe}
                                    id={item.spe}
                                    onClick={handleClickValueDiverse}
                                  >
                                    {item.spe}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Box>
                        </FormControl>
                      </div>
                    </div>
                    <div className="boxGrid">
                      {filteredValueToGrid.map(equip => (
                        <GridTreeOthers
                          key={equip.equipmentCode}
                          equipmentDescription={
                            'Equipamentos:  ' + equip.equipmentDescription
                          }
                          equipmentCode={equip.equipmentCode}
                          installation={equip.installation}
                          installationId={equip.installationId}
                          setEquipmentList={setEquipmentList}
                          toggleState={toggleState}
                        />
                      ))}
                    </div>
                  </div>
                </ContentTable>
              </div>
              <SplitPane split="horizontal" allowResize={false}>
                <SplitPane
                  split="vertical"
                  minSize={70}
                  maxSize={-70}
                  defaultSize={'35%'}
                >
                  <div className="simulationDiv">
                    <NewDailyBulletinPlanning
                      getNameActivity={getNameActivity}
                      values={values}
                      valueIdFornecedor={valueIdFornecedor}
                      tag={tagCheckbox}
                      idChecks={idChecks}
                      tagCheckEquipment={tagChecks}
                      providerName={providerName}
                      toggleState={toggleState}
                      valueIdFornecedorDiverse={valueIdFornecedorDiverse}
                      equipmentList={equipmentList}
                    />
                  </div>
                  <div className="statisticsDiv">
                    <NewDailyBulletinPreview
                      toggleState={toggleState}
                      installationSelected={install}
                    />
                  </div>
                </SplitPane>
              </SplitPane>
            </div>
          </div>
          {/* {isLoading && <Loading />} */}
        </div>
      </Modal>
      <Dialog
        open={openDialogAddFornecedor}
        onClose={() => {
          setOpenDialogAddFornecedor(false);
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" style={{ textAlign: 'center' }}>
          Digite o nome do novo fornecedor
        </DialogTitle>
        <DialogContent>
          <TextField
            id="txtObservacao"
            label="Observação:"
            inputRef={inputFornecedorAdd}
            defaultValue=""
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDialogAddFornecedor(false);
            }}
            color="secondary"
          >
            Cancelar
          </Button>
          <Button
            onClick={() => {
              setOpenDialogAddFornecedor(false);
              const options: any = [];

              typeOutros.map(item => {
                options.push({
                  label: item.label,
                  value: item.value,
                });
              });

              options.push({
                label: inputFornecedorAdd.current?.value,
                value: 0,
              });

              setTypeOutros(options);
            }}
            color="primary"
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalNewBulletim;
